import { render } from "./cpt-amount.vue?vue&type=template&id=096b1556&scoped=true"
import script from "./cpt-amount.vue?vue&type=script&lang=js"
export * from "./cpt-amount.vue?vue&type=script&lang=js"

import "./cpt-amount.vue?vue&type=style&index=0&id=096b1556&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096b1556"]])

export default __exports__